// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kmK2","textarea":"styles_textarea__1YmgN"};